import { Router } from 'express';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import * as masterBankController from './bank.controller';

const router: Router = Router();

router
  .route('/')
  .get(userAuthAndCheckPermissions(), masterBankController.getMasterBanks);

router
  .route('/:id')
  .get(userAuthAndCheckPermissions(), masterBankController.getMasterBankById);

export default router;
